import React from 'react'

import './editUserUsername.css'

const EditUserUsername = ({id, userData}: any) => {
  return (
    <div>EditUserUsername</div>
  )
}

export default EditUserUsername